module.exports = __webpack_public_path__ + "static/media/play-square.f6872d7a.svg";